import { render, staticRenderFns } from "./CreatePackageItem.vue?vue&type=template&id=47d15f72&scoped=true&"
import script from "./CreatePackageItem.vue?vue&type=script&lang=js&"
export * from "./CreatePackageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d15f72",
  null
  
)

export default component.exports